module.exports = __webpack_public_path__ + "static/media/custom_profie.010a974d.svg";